<template>
  <div class="content-center none-click">
    <div class="banner">
      <img src="@/assets/Mobile/images/solution/micromall_banner.png" alt="">
    </div>
    <div class="block01">
      <div class="sk-mobile-title">
        <div class="title">统一的管理后台</div>
        <div class="sub-title">支持微信、百度、快手等多平台开通微商城，高效卖货</div>
      </div>
      <div class="content">
        <div class="item">
          <img src="@/assets/Mobile/images/solution/mall01.png" alt="">
          <span>微信小程序</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/mall02.png" alt="">
          <span>app商城</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/mall03.png" alt="">
          <span>H5商城</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/mall04.png" alt="">
          <span>百度小程序</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/mall05.png" alt="">
          <span>快手小店</span>
        </div>
      </div>
    </div>
    <div class="block02">
      <div class="sk-mobile-title">
        <div class="title">线上商城+社群分销+营销互动<br>助力零售门店数字化升级</div>
      </div>
      <div class="content">
        <div class="item">
          <img src="@/assets/Mobile/images/solution/mall-icon01.png" alt="">
          <div class="right">
            <div class="title">搭建专属微商城</div>
            <div class="text">为门店打造专属私域流量平台，除门店自有商品和活动外，平台还额外叠加高频爆款商品及活动协助经营提升</div>
          </div>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/mall-icon02.png" alt="">
          <div class="right">
            <div class="title">社群分销裂变</div>
            <div class="text">利用社群熟人经济，帮门店发展代理人，通过代理人的拉新、商品分销，提高店铺品牌知名度和销量</div>
          </div>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/mall-icon03.png" alt="">
          <div class="right">
            <div class="title">店铺装修想换就换</div>
            <div class="text">自由拖拽、个性布局，丰富组件样式，多样的主题风格、配色，海量商城模板</div>
          </div>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/mall-icon04.png" alt="">
          <div class="right">
            <div class="title">丰富营销促销</div>
            <div class="text">秒杀、限时购、膨胀红包、大转盘、小猫钓鱼、摇奖机、积分乐园等等几十种营销促销活动，帮助门店玩转网店，活跃粉丝</div>
          </div>
        </div>
      </div>
    </div>
    <div class="block03">
      <div class="sk-mobile-title">
        <div class="title">持续更新营销活动插件</div>
        <div class="sub-title">秒杀、优惠券等各类主流营销工具，花样玩法，<br>助力商家深挖用户价值</div>
      </div>
      <div class="content">
        <div class="btns">
          <div>秒杀</div>
          <div>限时购</div>
          <div>拼团</div>
          <div>多人团</div>
          <div>抽奖团</div>
          <div>单品促销</div>
          <div>搭售套餐</div>
          <div>膨胀红包</div>
          <div>代理人券</div>
          <div>套圈圈</div>
          <div>拆盲盒</div>
          <div>小猫钓鱼</div>
        </div>
        <img src="@/assets/Mobile/images/solution/mall06.png" alt="">
      </div>
    </div>
    <div class="block04">
      <div class="sk-mobile-title">
        <div class="title">零售+分销，双轮驱动：获客、<br>留存、激活、裂变</div>
      </div>
      <div class="content">
        <img src="@/assets/Mobile/images/solution/mall07.png" alt="">
        <div class="btns">
          <div>平台任务</div>
          <div>店铺任务</div>
          <div>商品分销</div>
          <div>商品资源库</div>
          <div>图文分享</div>
          <div>下单即返</div>
          <div>优惠券转赠</div>
          <div>锁粉</div>
          <div>多种酬劳</div>
          <div>云池佣金</div>
          <div>等级权益</div>
          <div>提现便捷</div>
        </div>
      </div>
    </div>
    <div class="block03">
      <div class="sk-mobile-title">
        <div class="title">店铺随心装修，灵活便捷，模板精美</div>
        <div class="sub-title">可视化个性装修，组件随意拖曳，丰富的模板资源，满足不<br>同客户需求，不同管理角色，不同管理权限，权责更明确</div>
      </div>
      <div class="content">
        <div class="btns">
          <div>整体换肤</div>
          <div>个性装修</div>
          <div>特色聚合页</div>
          <div>楼层配置</div>
          <div>商品推荐配置</div>
          <div>快捷菜单</div>
          <div>店铺模版</div>
          <div>店铺banner</div>
          <div>营销组件</div>
          <div>广告位配置</div>
          <div>温馨问候</div>
          <div>公告信息</div>
        </div>
        <img src="@/assets/Mobile/images/solution/mall08.png" alt="">
      </div>
    </div>
    <div class="industry-solution">
      <div class="sk-mobile-title">
        <div class="title">行业解决方案</div>
      </div>
      <div class="content">
        <div class="item">
          <img src="@/assets/Mobile/images/solution/industry_solution1.png" alt="">
          家用电器
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/industry_solution2.png" alt="">
          农资行业
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/industry_solution3.png" alt="">
          交通出行
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/industry_solution4.png" alt="">
          酒水饮料
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/industry_solution5.png" alt="">
          家居建材
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/industry_solution6.png" alt="">
          数码3C
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/industry_solution7.png" alt="">
          餐饮行业
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/industry_solution8.png" alt="">
          快消行业
        </div>
      </div>
    </div>
    <div class="block05">
      <div class="sk-mobile-title">
        <div class="title">他们都在用微商城电商解决方案</div>
        <div class="sub-title">赋能零售门店，刷新线上赛道成绩</div>
      </div>
      <div class="content">
        <div class="item">
          <div class="left">
            <div><span class="title">盱眙龙虾</span><span class="sub-title">美食</span></div>
            <div class="line2"><span class="num">100</span><span class="unit">万+</span></div>
            <span class="des">单日销售数量</span>
            <div class="text">即使面临线下场景被阻断，也能通过线上营销迅速找回客户，突破销量。</div>
            <div class="btn" @click="openModal">免费开店</div>
          </div>
          <img src="@/assets/Mobile/images/solution/mall09.png" alt="">
        </div>
        <div class="item">
          <div class="left">
            <div><span class="title">苏垦大米</span><span class="sub-title">农产品</span></div>
            <div class="line2"><span class="num">2</span><span class="unit">万单</span></div>
            <span class="des">1小时售罄</span>
            <div class="text">直播带货帮助商家获取流量，达到品牌曝光和卖货的双重目的。</div>
            <div class="btn" @click="openModal">免费开店</div>
          </div>
          <img src="@/assets/Mobile/images/solution/mall10.png" alt="">
        </div>
        <div class="item">
          <div class="left">
            <div><span class="title">清林家电</span><span class="sub-title">家电</span></div>
            <div class="line2"><span class="num">8</span><span class="unit">万+</span></div>
            <span class="des">活动期间提升营业额</span>
            <div class="text">利用秒杀和砍价活动通过小程序网店在微信群分享，实现了引流新粉、转化促活。</div>
            <div class="btn" @click="openModal">免费开店</div>
          </div>
          <img src="@/assets/images/micromall/micromall_online03.png" alt="">
        </div>
        <div class="item">
          <div class="left">
            <div><span class="title">快优到家</span><span class="sub-title">百货</span></div>
            <div class="line2"><span class="num">24</span><span class="unit">万+</span></div>
            <span class="des">分销订单</span>
            <div class="text">通过代理人模式，分销商品销售额占比近30%，销售业绩持续增长。</div>
            <div class="btn" @click="openModal">免费开店</div>
          </div>
          <img src="@/assets/images/micromall/micromall_online04.png" alt="">
        </div>
      </div>
    </div>
    <Case title="微商城" />
    <ContactForm info-sources="微商城" />
    <TryModal v-if="tryVisible" :visible="tryVisible" info-sources="B2B2C" @cancel="modalClose" />

  </div>
</template>

<script>
import metaInfo from '@/common/util/metaInfo'
import ContactForm from '@/Mobile/Mobilecom/ContactForm'
import IndustrySolution from '@/Mobile/Mobilecom/IndustrySolution'
import Case from '@/Mobile/Mobilecom/Case'
import TryModal from '@/Mobile/Mobilecom/TryModal'

export default {
  metaInfo: metaInfo.Micromall,
  components: {
    ContactForm,
    IndustrySolution,
    Case,
    TryModal
  },
  data() {
    return {
      tryVisible: false
    }
  },
  mounted() {

  },
  methods: {
    openModal: function() {
      this.tryVisible = true
    },
    modalClose: function(data) {
      this.tryVisible = data
    }
  }
}
</script>

<style lang="less" scoped>
.banner {
  width: 100%;
  height: 200px;
  margin-top: 50px;
  img {
    display: block;
    width: 100%;
    height: 100%;
  }
}
.block01 {
  .content {
    padding: 20px 0 30px 0;
    display: flex;
    width: 375px;
    justify-content: space-evenly;
    .item {
      margin-top: 7px;
      display: flex;
      flex-direction: column;
      font-size: 6px;
      line-height: 16px;
      color: #000000;
      span {
        margin-top: 12px;
        font-size: 10px;
        font-weight: 500;
        color: #595961;
        line-height: 14px;
      }
    }
    img {
      width: 57px;
    }
  }
}
.block02 {
  background-color: #FAFAFA;
  .content {
    padding: 20px 17px 15px 17px;
    display: flex;
    flex-direction: column;
    .item {
      margin-top: 16px;
      display: flex;
      justify-content: space-between;
      .title {
        font-size: 14px;
        font-weight: 500;
        color: #595961;
        line-height: 20px;
      }
      .text {
        margin-top: 6px;
        font-size: 10px;
        font-weight: 400;
        color: #8B8FA1;
        line-height: 16px;
      }
    }
    .right {
      margin-left: 10px;
      text-align: left;
    }
  }
  img {
    width: 27px;
    height: 27px;
  }
}
.block03 {
  .content {
    padding: 19px 0 25px 0;
    .btns {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      &>div {
        margin: 7px 8px;
        width: 104px;
        height: 39px;
        border-radius: 3px;
        border: 1px solid #8760F1;
        line-height: 39px;
        font-size: 12px;
        font-weight: 400;
        color: #8760F1;
      }
    }
    img {
      margin-top: 19px;
      width: 285px;
    }
  }
}
 .industry-solution {
    height: 318px;
    background: url("~@/assets/Mobile/images/home/industry-bg.png") no-repeat center;
    background-size: 102%;
    .title {
      color: #fff !important;
    }
    .content {
      padding: 16px 0 14px 0;
      display: flex;
      width: 375px;
      flex-wrap: wrap;
      justify-content: space-evenly;
      .item {
        display: flex;
        flex-direction: column;
        margin: 15px;
        font-size: 12px;
        line-height: 32px;
        color: #FFFFFF;
      }
      img {
        width: 62px;
        height: 62px;
      }
    }
  }
.block04 {
  background-color: #FAFAFA;
  .content {
    padding: 19px 0 25px 0;
    .btns {
      margin-top: 24px;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      &>div {
        margin: 7px 8px;
        width: 104px;
        height: 39px;
        border-radius: 3px;
        border: 1px solid #8760F1;
        line-height: 39px;
        font-size: 12px;
        font-weight: 400;
        color: #8760F1;
      }
    }
    img {
      margin-top: 19px;
      width: 336px;
    }
  }
}
.block05 {
  background-color: #FAFAFA;
  .content {
    padding: 28px 16px 20px 16px;
    .item {
      padding: 27px 20px;
      background: #FFFFFF;
      box-shadow: 0px 0px 7px 0px rgba(221, 221, 221, 0.5);
      border-radius: 4px;
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
      img {
        display: block;
        width: 137px;
        height: 164px;
      }
      .left {
        display: flex;
        width: 140px;
        flex-direction: column;
        justify-content: start;
        align-items: flex-start;
        .title {
          font-size: 16px;
          font-weight: 500;
          color: #595961;
          line-height: 23px;
          padding-right: 9px;
          border-right: 1px solid #D8D8D8;
        }
        .sub-title {
          padding-left: 9px;
          font-size: 12px;
          font-weight: 400;
          color: #8B8FA1;
          line-height: 17px;
        }
        .line2 {
          margin-top: 4px;
        }
        .des {
          font-size: 10px;
          font-weight: 400;
          color: #8B8FA1;
          line-height: 14px;
        }
        .num {
          font-size: 16px;
          font-weight: 500;
          color: #FF8C11;
          line-height: 23px;
        }
        .unit {
          font-size: 10px;
          font-weight: 400;
          color: #8B8FA1;
          line-height: 14px;
        }
        .text {
          margin-top: 11px;
          font-size: 10px;
          font-weight: 400;
          color: #595961;
          line-height: 16px;
          text-align: left;
        }
        .btn {
          margin-top: 20px;
          width: 71px;
          height: 22px;
          background: #8760F1;
          border-radius: 3px;
          font-size: 10px;
          color: #FFFFFF;
          line-height: 22px;
        }
      }
    }
  }
}
</style>
